module.exports = __webpack_public_path__ + "img/darkActive.b6e118a2.svg";